import React from "react";
import i18n from "i18next";
import PropTypes from "prop-types";
import AppModal from "../common/modal/AppModal";

// Sync Scene reads the scene audio from the SAVED training, so a sound added
// since the last save is invisible to it. Asked before every sync while there
// are unsaved changes (EditorApp.handleSyncScene).
export default function SaveBeforeSyncModal({ show, saving, error, onCancel, onSaveAndSync }) {
  const footer = (
    <div className="app-modal__footer">
      <button
        type="button"
        className="app-modal__btn app-modal__btn--ghost"
        onClick={onCancel}
        disabled={saving}
      >
        {i18n.t("messages.syncScene.saveFirst.cancel")}
      </button>
      <button
        type="button"
        className="app-modal__btn app-modal__btn--primary"
        onClick={onSaveAndSync}
        disabled={saving}
      >
        {saving
          ? i18n.t("messages.syncScene.saveFirst.saving")
          : i18n.t("messages.syncScene.saveFirst.confirm")}
      </button>
    </div>
  );

  return (
    <AppModal
      show={!!show}
      onClose={saving ? () => {} : onCancel}
      title={i18n.t("messages.syncScene.saveFirst.title")}
      size="md"
      closeButton={false}
      showSceneToggle={false}
      footer={footer}
    >
      {i18n.t("messages.syncScene.saveFirst.body")}
      {error && <div style={{ color: "#dc3545", marginTop: 12, fontSize: 13 }}>{error}</div>}
    </AppModal>
  );
}

SaveBeforeSyncModal.propTypes = {
  show: PropTypes.bool,
  saving: PropTypes.bool,
  error: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSaveAndSync: PropTypes.func.isRequired,
};
